import { FormPage } from '@checkit/react-components';
import { AddIcon } from '@checkit/react-components/build/components/Icons';
import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps } from 'react-router';
import { AnyAction } from 'redux';

import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import { createCheckpointType, isCreateCheckpointTypeSuccess } from '../actions';
import CheckpointTypeForm from '../form/CheckpointTypeForm';
import { CheckpointTypeData } from '../state';

import { messages } from './NewCheckpointType.translations';

export const NewCheckpointType: React.FC<RouteComponentProps> = ({ history }) => {
  const { formatMessage } = useIntl();
  const dispatch = useAxiosDispatch( );

  const onSubmit = async (data: CheckpointTypeData): Promise<AnyAction> => {
    const action = await dispatch(createCheckpointType(data, history));

    if (isCreateCheckpointTypeSuccess(action)) {
      dispatch(createSnackbar({
        message: formatMessage(messages['checkpointType.new.success']),
        options: {
          variant: 'success'
        }
      }));
    } else {
      const errorType = action.error ? (action as any).error.response.data.message : null;
      if (errorType === messages.CHECKPOINT_TYPE_NAME_NOT_UNIQUE.id) {
        dispatch(createSnackbar({
          message: formatMessage(messages.CHECKPOINT_TYPE_NAME_NOT_UNIQUE),
          options: {
            autoHideDuration: 6000,
            variant: 'error'
          }
        }));
      } else {
        dispatch(createSnackbar({
          message: formatMessage(messages['checkpointType.new.error']),
          options: {
            variant: 'error'
          }
        }));
      }
    }
    return action;
  };

  return (
    <FormPage pageTitle={formatMessage(messages['checkpointType.new.pageTitle'])} pageIcon={<AddIcon />}>
      <CheckpointTypeForm code={null} onSubmit={onSubmit} />
    </FormPage>
  );
};
